import { ILanguage } from "../../../core/model/language/Language";
import { IIndexTypeGroup } from "../../../indexTypes/model/IndexTypeGroup";
import OrganisationIndexGroupPresentationModel, {
  TOrganisationIndexGroupPresentationModel
} from "./OrganisationIndexGroupPresentationModel";

export interface TIndexTypeGroupPresentationModel extends IIndexTypeGroup {
  organisationIndexGroupList: TOrganisationIndexGroupPresentationModel[];
  nameTranslation: string;
  childGroups: TIndexTypeGroupPresentationModel[];
}

const IndexTypeGroupPresentationModel = (
  data: IIndexTypeGroup,
  selectedLanguage: ILanguage
) => {
  const organisationIndexGroupList = data.organisationIndexGroupList?.filter(
    (value) => value.indexTypeGroupId === data.id
  );
  const childGroups = data.childGroups?.map((item) =>
    IndexTypeGroupPresentationModel(item, selectedLanguage)
  );
  const handler: ProxyHandler<IIndexTypeGroup> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "childGroups":
          return childGroups;
        case "organisationIndexGroupList":
          return organisationIndexGroupList?.map((category) => {
            return OrganisationIndexGroupPresentationModel(
              category,
              selectedLanguage
            );
          });

        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "organisationGroups":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IIndexTypeGroup, TIndexTypeGroupPresentationModel>(
    data,
    handler
  );
};

export default IndexTypeGroupPresentationModel;
